<template>
  <v-checkbox
    class="bm-checkbox"
    :input-value="inputValue"
    :value="value"
    :label="labelVal"
    v-bind="$attrs"
    :hide-details="hideDetails"
    :data-qa="dataQa"
    @change="$emit('change', $event)"
    @focus="bubbleEvent($event)"
    @blur="bubbleEvent($event)"
  >
    <template #label>
      <slot name="label" />
    </template>
  </v-checkbox>
</template>

<script lang="ts">
import BmLabelled from "@/components/controls/input/mixins/BmLabelled";
import BmInputField from "@/components/controls/input/mixins/BmInputField";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmCheckbox",
  mixins: [BmLabelled, BmInputField],
  inheritAttrs: false,
  model: {
    prop: "inputValue",
    event: "change",
  },
  props: {
    inputValue: {
      required: false,
    },
    value: {
      required: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  inject: {
    check: { from: "check", default: "" },
  },
  mounted() {
    // Remove ts-ignore when resolved: https://github.com/vuejs/core/issues/3031

    // @ts-ignore
    if (this.check) {
      // @ts-ignore
      this.check.register(this);
    }
  },
  beforeDestroy() {
    // @ts-ignore
    if (this.check) {
      // @ts-ignore
      this.check.unregister(this);
    }
  },
});
</script>

<style lang="sass">
@import "src/sass/typography"

.bm-checkbox label.v-label
  @include bm-body

.bm-checkbox
  margin-top: 0!important
</style>
